<div class="hero-text-container">
    <h2>{{ leadData.title }}</h2>
    <p>{{ leadData.subtitle }}</p>

    <div class="divider-container">
        <div class="content"></div>
    </div>
</div>
